import classNames from 'classnames'
import { ButtonHTMLAttributes } from 'react'
import buttonMinimalStyles from './buttonMinimal.module.scss'
import linkStyles from '@components/ui/Link/styles.module.scss'
import { ButtonClasses } from './ButtonBase'

type ButtonTextSize = 'regular' | 'large' | 'small'

export type ButtonMinimalProps = {
  classes?: ButtonClasses
  children: React.ReactNode
  textSize?: ButtonTextSize
  underlined?: boolean
  variant?: 'primary' | 'white' | 'success' | 'inherit'
} & ButtonHTMLAttributes<HTMLButtonElement>

const ButtonMinimal = ({
  variant = 'primary',
  classes,
  children,
  textSize = 'regular',
  underlined = false,
  ...props
}: ButtonMinimalProps) => {
  const buttonClasses = classNames(
    linkStyles.link,
    linkStyles[`textSize_${textSize}`],
    linkStyles[variant],
    buttonMinimalStyles.buttonMinimal,
    classes,
    {
      [linkStyles.underlined]: underlined
    }
  )

  return (
    <button {...props} className={buttonClasses} type="button">
      {children}
    </button>
  )
}

export default ButtonMinimal
